import React, { useContext } from 'react';

import { withStyles } from '@material-ui/core/styles';

import { ExpandButton } from '../../../button';

import { PanelContext } from '../../index';

import styles from './styles';

export const PanelExpandButton = props => {
  const { classes, className, children, ...other } = props;

  const { isOpen, toggleOpen } = useContext(PanelContext);

  return (
    <ExpandButton
      data-testid="panel-expand-button"
      className={className}
      classes={classes}
      onClick={() => toggleOpen(isOpen)}
      open={isOpen}
      {...other}
    />
  );
};

export default withStyles(styles)(PanelExpandButton);
